import destroy from './destroy';
import store from './store';
import show from './show';
import update from './update';
import all from './all';
import items from './items';
import counts from './counts';

export default {
  destroy,
  store,
  show,
  update,
  all,
  items,
  counts,
};



// WEBPACK FOOTER //
// ./src/app/services/supplier/index.js